/* Copyright (c) 2020-present CloudIO Inc */

import { Platform } from '../../../platform/Platform';
import { ComponentManagerFn } from '../../../registry/Component.type';
import { ItemType } from '../../../registry/ComponentRegistry';
import { baseComponentManager } from '../../../registry/Components';
import { toOptions } from '../../../utils/ManagerUtils';
import { defaultValue } from './ColumnFooter';

const ColumnFooterManager: ComponentManagerFn<'ColumnFooter'> = (
  platform: Platform,
) => {
  return {
    ...baseComponentManager<'ColumnFooter'>(platform, 'ColumnFooter'),
    type: 'ColumnFooter',
    name: 'Column Footer',
    isChildAllowed: (page, item, childType) =>
      (['TriggerOnClick'] as ItemType[]).includes(childType),
    defaultValue,
    props: {
      summaryFunction: {
        label: 'Summary Function',
        type: 'select',
        category: 'UI',
        options: async (item, { appUid, pageId }) => {
          const parent = platform.getItem(appUid, pageId, item.parent);
          return toOptions(
            parent?.type === 'NumberColumn'
              ? ['sum', 'avg', 'min', 'max', 'count', 'none']
              : ['count', 'none'],
          );
        },
        useDropDown: (item, { appUid, pageId }) => {
          const parent = platform.getItem(appUid, pageId, item.parent);
          return parent?.type === 'NumberColumn';
        },
        required: true,
      },
      formatExpression: {
        label: 'Format Expression',
        type: 'expressionOnly',
        category: 'UI',
        returnType: () => 'string',
        helpText:
          // eslint-disable-next-line no-template-curly-in-string
          "Use $._.summary to access the calculated summary value. e.g. `${t('Sum')}: ${formatNumber($._.summary)}`",
        placeholder: 'formatNumber($._.summary)',
      },
      excelSummaryFunction: {
        label: 'Excel Summary Expression',
        type: 'string',
        category: 'Export',
        returnType: () => 'string',
        helpText:
          'Use sum(#{attributeCode}) + min(#{attributeCode}) (Availabe functions: sum, avg, min, max, count)',
        placeholder: 'sum(#{attributeCode})',
      },
      excelSummaryFormatter: {
        label: 'Excel Summary Formatter',
        type: 'string',
        category: 'Export',
        returnType: () => 'string',
        helpText: 'Use ###.#### , $###,###.## , ##.00% etc',
      },
    },
    isAllowedInsideParent: (page, parent, { appUid, itemId, pageId, mgr }) => {
      // footer is not yet supported for canvas grid
      if (platform.findParentOfType(appUid, pageId, itemId, 'CanvasGrid')) {
        return `${mgr.name} is not supported inside Canvas Grid!`;
      }
      return true;
    },
    getDisplayText: (item) => item.props.summaryFunction,
    category: 'Forms',
    icon: { iconName: 'sigma' },
    description: '!!!MAKE SURE TO PROVIDE A DESCRIPTION!!!',
  };
};

export default ColumnFooterManager;
